import { clone, without, isEmpty, difference } from 'lodash'
import { Component, createRef } from 'react'
import NotificationsList from './notifications_list'
import Button from '../Button'

export default class NotificationsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedNotifications: [],
      formAction: '#',
      formMethod: 'POST',
    }
    this.$notificationsListRef = createRef()
  }

  onSelectNotification = (notification, selected) => {
    const { selectedNotifications } = this.state
    let newSelection = []
    if (selected) {
      newSelection = clone(selectedNotifications).concat([notification])
    } else {
      newSelection = without(selectedNotifications, notification)
    }
    this.setState({
      selectedNotifications: newSelection,
    })
  }

  handleSelectAllClick = event => {
    const { notifications } = this.props
    const selectedNotifications = event.currentTarget.checked ? notifications : []
    this.setState({
      selectedNotifications,
    })
  }

  handleTrashSelectedClick = event => {
    this.setState(
      {
        formAction: this.props.bulkDeleteNotificationsPath,
        formMethod: 'DELETE',
      },
      this.submitForm
    )
  }

  handleReadSelectedClick = result => {
    this.setState(
      {
        formAction: this.props.bulkReadNotificationsPath,
        formMethod: 'PUT',
      },
      this.submitForm
    )
  }

  handleUnreadSelectedClick = event => {
    this.setState(
      {
        formAction: this.props.bulkUnreadNotificationsPath,
        formMethod: 'PUT',
      },
      this.submitForm
    )
  }

  submitForm() {
    this.$notificationsListRef.current.submit()
  }

  getNumberOfNotificationsText(num) {
    return num === 1 ? '1 notification' : `${num} notifications`
  }

  render() {
    const { notifications } = this.props
    const { selectedNotifications } = this.state
    const selectAllChecked = !isEmpty(notifications) && isEmpty(difference(notifications, selectedNotifications))
    const numTotal = notifications.length
    const disableSelectAll = numTotal === 0
    const disableButtons = selectedNotifications.length === 0
    const numNotificationsText = this.getNumberOfNotificationsText(numTotal)
    return (
      <div className="p">
        <h3 className="zeta">You have {numNotificationsText}</h3>
        <header className="list-controls">
          <div className="list-controls__section">
            <div className="list-controls__item control-small--select-all-form checkbox-container checkbox-container--single">
              <input
                className="toggle-checkbox-selection-checkbox"
                type="checkbox"
                checked={selectAllChecked}
                readOnly
                onClick={this.handleSelectAllClick}
                disabled={disableSelectAll}
              />
            </div>
            <Button
              className="list-controls__item control"
              onClick={this.handleTrashSelectedClick}
              disabled={disableButtons}
            >
              Trash
            </Button>
            <Button
              className="list-controls__item control"
              onClick={this.handleReadSelectedClick}
              disabled={disableButtons}
            >
              Mark as read
            </Button>
            <Button
              className="list-controls__item control"
              onClick={this.handleUnreadSelectedClick}
              disabled={disableButtons}
            >
              Mark as unread
            </Button>
          </div>
        </header>
        <NotificationsList
          ref={this.$notificationsListRef}
          notifications={notifications}
          formAction={this.state.formAction}
          formMethod={this.state.formMethod}
          selectedNotifications={selectedNotifications}
          onSelectNotification={this.onSelectNotification}
        />
      </div>
    )
  }
}
